interface SlideOptions {
  delay?: number;
  duration?: number;
  translate?: number;
  direction?: 'left' | 'right';
  startOpacity?: number;
  isOut?: boolean;
  delayOpacity?: number;
  opacityDuration?: number;
}

export function slide(node: HTMLElement, options: SlideOptions = {}) {
  const {
    delay = 0,
    duration = 200,
    translate = 100,
    direction = 'right',
    startOpacity = 0,
    isOut = false,
    delayOpacity = 0,
    opacityDuration = duration,
  } = options;

  const dx = direction === 'right' ? translate : -translate;
  const start = isOut ? 0 : dx;
  const end = isOut ? dx : 0;

  // Prevent initial flash by setting styles immediately
  // Preserve existing inline styles by setting individual properties
  node.style.opacity = isOut ? '1' : String(startOpacity);
  node.style.transform = `translateX(${start}%)`;
  node.style.transition = 'none';
  node.style.visibility = 'visible';

  // Schedule the animation
  setTimeout(() => {
    // Start transform transition
    node.style.transition = `transform ${duration}ms ease-in-out`;
    node.style.transform = `translateX(${end}%)`;

    // Start opacity transition after delay
    setTimeout(() => {
      node.style.transition = `
        transform ${duration}ms ease-in-out,
        opacity ${opacityDuration}ms ease-in-out
      `;
      node.style.opacity = isOut ? startOpacity : '1';
    }, delayOpacity);
  }, delay);

  return {
    duration,
    destroy() {
      node.style.opacity = '';
      node.style.transform = '';
      node.style.transition = '';
      node.style.visibility = '';
    },
  };
}
